export enum DeviceType {
    OrionAir = 'Orion Air',
    OrionGo = 'Orion Go',
    OrionComplete = 'Orion Complete',
}
